<template>
    <div class="modal-serviceEdit">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                             <el-col :span="12" class="item">
                                <el-form-item label="注册账号（手机号）" required prop="phone">
                                    <el-input v-model="editForm.phone"  maxlength="11" placeholder="请输入注册账号"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="姓名" required prop="name">
                                    <el-input v-model="editForm.name" placeholder="请输入收银员姓名"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="性别" required prop="gender">
                                    <el-radio-group v-model="editForm.gender" style="width:100%">
                                        <el-radio :label="0">女</el-radio>
                                        <el-radio :label="1">男</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="状态" required prop="status">
                                    <el-select v-model="editForm.status" placeholder="请选择状态" style="width:100%">
                                        <el-option
                                                v-for="item in statusValues"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: 'Add',
        data() {
            return {


                statusValues: [
                   {
                    value: 1, label: '正常'
                  }, {
                    value: 2, label: '禁用'
                  },
                ],


                loading: false,
                healthCardsFileList:[],
                qualificationFileList:[],
                uploadUrl:this.$shopUrl+'Upload/Imgs',
                uploadUrl1:this.$shopUrl+'Upload/File',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },
                qualificationImageUrl:'',
                qualificationVisible:false,
                healthCardsImageUrl:'',
                healthCardsVisible:false,
                defaultProps: {
                    children: 'listMenuDTO',
                    label: 'name'
                },
                serviceTypeValue:['兼职','专职'],
                serviceStatusValue:['正常服务','停止服务'],

                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    phone:'',
                    status:'',
                    gender:0,
                    cashierCode:''
                },

                rules:{
                    phone:[
                        { required: true, message: '请输入注册账号', trigger: 'blur' },
                        {
                            pattern: /^1[3456789]\d{9}$/,
                            message: '请输入正确的手机号'
                        },
                    ],
                    password:[
                        { required: true, message: '请输入注册密码', trigger: 'blur' },
                    ],
                     name:[
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                    ],
                },
            }
        },

        methods: {
            init(row){
                this.$refs.editForm.resetFields();
                this.editForm.name=row.name
                this.editForm.phone=row.phone
                this.editForm.status=row.status
                this.editForm.gender=row.gender
                this.editForm.cashierCode=row.cashierCode
            },
            qualificationBefore(file){
                console.log(file.name)
                var name=file.name;
                name=name.slice(-3)
                if(name!='jpg'&&name!='peg'&&name!='png'){
                    this.$message({type: 'info', message: '请上传jpg/jpeg/png格式的图片'});
                    // this.qualificationFileList=[]
                    return false;
                }
            },
            healthCardsBefore(file){
                console.log(file.name)
                var name=file.name;
                name=name.slice(-3)
                if(name!='jpg'&&name!='peg'&&name!='png'){
                    this.$message({type: 'info', message: '请上传jpg/jpeg/png格式的图片'});
                    // this.healthCardsFileList=[]
                    return false;
                }
            },
            qualificationRemove(file, fileList) {
                console.log(file, fileList);
                this.editForm.qualification = '';
            },
            qualificationSuccess(res, file) {
                console.log(file)
                this.editForm.qualification = this.$imgUrl+res.data.path;
            },
            qualificationPreview(file) {
                this.qualificationImageUrl = file.url;
                this.qualificationVisible = true;
            },
            healthCardsRemove(file, fileList) {
                console.log(file, fileList);
                this.editForm.healthCards = '';
            },
            healthCardsSuccess(res, file) {
                console.log(file)
                this.editForm.healthCards = this.$imgUrl+res.data.path;
            },
            healthCardsPreview(file) {
                this.healthCardsImageUrl = file.url;
                this.healthCardsVisible = true;
            },
            closeSelf() {
                this.healthCardsFileList=[]
                this.qualificationFileList=[]
                this.$emit("closeEdit");
            },
             handleImgSuccess(res, file) {
                 console.log(file)
                this.editForm.img = this.$imgUrl+res.data.path;
            },
            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        this.$message({type: 'info', message: '请完善信息'});
                        return false;
                    }
                })

            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Cashier/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },


        }
    }


</script>




<style lang="scss" scoped>

    .modal-serviceEdit {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 700px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
                width:100px;
                height: 100px;
            }
            .modal-body  .avatar-uploader .el-upload:hover {
                border-color: #409EFF;
            }
            .modal-body   .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 100px;
                height: 100px;
                line-height: 100px;
                text-align: center;
            }
            .modal-body .avatar {
                width: 100px;
                height: 100px;
                display: block;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y:auto;
                height: 300px;
            }
            .upload-demo{
                margin-top: 40px;
            }
            .modal-body /deep/ .el-upload--picture-card{
                width: 100px;
                height: 100px;
                line-height: 100px;
            }
            .modal-body /deep/ .el-upload--picture {
                display: inline;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
